export function changeArray(data) {
    if (data && data.length) {
        return data.map(i => ({value: i.user_id, label: i.username, id: i.id}))
    }
}